import React, { Component } from "react";
import * as echarts from 'echarts';
import moment from "moment";
import download from "./downloadCSV.jpg";
import close from "../../minimise_button.png";
import "./AnalysisTool.css";

class CChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertShown: false
    };
  }
  componentDidMount() {
    this.renderChart();
  }

  componentDidUpdate() {
    this.renderChart();
  }
  closeAlert = () => {
    this.setState({ alertShown: false });
  }
  exportToCSV = () => {
    const { dates, data, title } = this.props;
    const { alertShown } = this.state;
        
          // Convert data to CSV format
          const csvContent = `${this.props.timestampselected === "Fortnightly" ? "Fortnight" : "Month"},${title}\n` +
            dates.map((timestamp, index) => {
              const prefix =timestamp
              const formattedDate = prefix;
              const value = data[index] !== null ? data[index] : 'Cloud';
              return `${formattedDate},${value}`;
            }).join("\n");
          
          
          // Create a Blob containing the CSV data
          const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
        
          // Create a link element and trigger a download
          const a = document.createElement('a');
          a.href = URL.createObjectURL(csvBlob);
          a.download = `${title}.csv`;
          a.click();

 
};

  
  renderChart() {
    const { data, dates, toggleVisibleGraphPanel, title } = this.props;
    const { alertShown } = this.state;

    // Check for data availability
    if (!dates || dates.length === 0) {
      // If dates is empty and alert has not been shown yet, display a message
      if (!alertShown) {
        this.setState({ alertShown: true }); // Set the flag to indicate that alert has been shown
      }
      return;
    }    
    const chart = echarts.init(document.getElementById("chart-container"));
    console.log("seriesdatabefore",dates)
    let date=dates.sort(function(a, b){return a - b});
    console.log("seriesdatabefore after sort",date)


    const seriesData = date.map((timestamp, index) => [timestamp, parseFloat(data[index])]);
    console.log("seriesdataafter",seriesData)
    const option = {
      color: ["#3398DB"],
      title: {
        top: '5%',
        left: 'center',
        text: title
      },
      toolbox: {
        show: true,
       
       
        feature: {
         
          dataZoom: {
            yAxisIndex: 'none',
            title: {
              zoom: 'Zoom In',
              back: 'Zoom Out',
            },
          
          },
          // brush: {
          //   type: ['rect', 'polygon', 'lineX', 'lineY','keep','clear'],
          //   title: {
          //     rect: 'Select Rectangular Area',
          //     polygon: 'Select Polygon Area',
          //     lineX: 'Select Horizontal Line',
          //     lineY: 'Select Vertical Line',
          //     keep: 'Keep Original',
          //    clear: 'Clear Selection',
             
          //   },
          
    
          //},
          magicType: {
            type: ["bar","line"],

            title: {
              line: 'Line Chart',
              bar: 'Bar Chart',
              //stack: 'Stacked Chart',
             // keep: 'Keep Original',
              //clear: 'Clear All',
            },
          },
          dataView: { 
            download:true,
            show: true, 
            title: 'View Data Points',
            readOnly: false, // Whether the data view is read-only or editable
            lang:[`${title}`,'close','Refresh'], // Custom language for the data view button
            textareaBorderColor: '#fff', // Border color of the textarea in the data view panel
            onclick: function(){
              // Custom action when the data view button is clicked
              // This function can be used to trigger a modal or any other action you want
            },
           
            optionToContent: () => {
              const { dates, data, title, timestampselected } = this.props;
              let table = '<table style="width:100%;text-align:center"><tbody>';
              // Add table headers
              table += `<tr><td>${this.props.timestampselected === "Fortnightly" ? "Fortnight" : "Month"}</td><td>${title}</td></tr>`;

              // Add table rows
              dates.forEach((timestamp, index) => {
                let prefix;
                
                
                  prefix = timestamp
                
                const value = data[index] !== null ? data[index] : 'Cloud';
                table += '<tr><td>' + prefix + '</td><td>' + value + '</td></tr>';
              });
              table += '</tbody></table>';
              return table;
            }

          },
            //dataView: { title: 'View Points', lang:['Evapotranspiration Data','close','Refresh'],show: true,readOnly: false ,download:true},
            restore: {title: 'Restore', show: true},

          saveAsImage: {
            show: true,
            title: "Save As Image",
          },
          myExportCSV: {  // Custom CSV button
            show: true,
            title: "Export to CSV",
            icon: `image://${download}`,  // You can replace this with the path to your custom icon
            onclick: this.exportToCSV,
          },
          myClose: {
            show: true,
            title: "Minimize",
            icon: `image://${close}`,
            onclick: toggleVisibleGraphPanel,
          },
        //  mySaveAsCSV: { // Custom CSV button
          //  show: true,
          //  title: "Save As CSV",
           // onclick: () => this.saveAsCSV(seriesData),
         // },
        },
      },
      xAxis: {
        type: "category",
        name:this.props.timestampselected==="Fortnightly"? "Fortnight":"Month",
        // axisLine: {
        //   onZero: true // Ensures that the x-axis line passes through the zero value of the y-axis
        // }
        nameTextStyle: {
          //align: "center",
          fontWeight: "bold", // Set to "bold" to make the name bold

          lineHeight: 50
        },
       // data:dates,
       data: dates, // Extracting the date labels from the series data
        axisLabel: {
            formatter: (value, index) => value // No need for formatting since the labels are already in the desired format
              },
        label: {
            show: true,
            //position: 'top',
        },

       
        
        splitLine: {
          show: false  // Remove x-axis split lines (vertical grid lines)
        },
        boundaryGap: false, // Set to true to align labels with the corresponding positions
      },
      yAxis: {
        type: "value",
        nameLocation: "middle",

        
        name: this.props.timeseries_y_axis, // Replace with your Y-Axis title
        nameTextStyle: {
          align: "center",
          verticalAlign: "bottom",
          fontWeight: "bold", // Set to "bold" to make the name bold

          lineHeight: 50
        },
        splitLine: {
          show: false  // Remove x-axis split lines (vertical grid lines)
        },

      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
            animation: true,
        },

        
        formatter: (params) => {
          
              const prefix = params[0].value[0];
              const value = params[0].value[1] !== 'NAN' ? `${parseFloat(params[0].value[1]).toFixed(3)} mm/day` : "Cloud";
              return `${prefix}: ${value}`;
          
        }
    },
    
      series: [
        {
          name: "Series Name", // Replace with your series name
          type : "line",
          data: seriesData,
          smooth: true, // Add this option for a smooth line
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0, color: 'rgba(51, 152, 219, 0.8)' // Start color
              }, {
                offset: 1, color: 'rgba(255, 255, 255, 0)' // End color (transparent)
              }],
            },
          },
        },
      ],
    };

    if (!dates || dates.length === 0) {
      // If dates is empty and alert has not been shown yet, display an alert
      if (!this.state.alertShown) {
        console.log("dates, dates.length", dates, dates.length);
        alert(`No data is available for ${title} between the selected time range` );
        this.setState({ alertShown: true }); // Set the flag to indicate that alert has been shown
      }
      return null; // Return null to prevent rendering an empty box
    }
    
if (dates || dates.length !== 0){
  chart.setOption(option);
}
    
  }

  render() {
    const { dates } = this.props;
    const { alertShown } = this.state;
    console.log("this.props.time")
    console.log("this.props.time",this.props.timestampselected)
    

    return (
      <div>
      {alertShown && (!dates || dates.length === 0) ? (
        <div className="alert">
          <span>No data is available for {this.props.title} between the selected time range</span>
          <br/>
          {/* Replace with your custom close button */}
          <button className="my-close-btn" onClick={this.props.toggleVisibleGraphPanel}>Close</button>
        </div>
      ) : (
        <div id="chart-container" style={{ height: "400px",width:"800px" }} />
      )}
    </div>
    );
  }
}

export default CChart;
